import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center bg-gray-50 px-6">
      {/* Illustration */}
      <motion.img
        src="assets/images/not-found.jpg"
        alt="404 illustration"
        className="w-64 mb-6"
        height={200}
        width={800}
      />

      {/* Bouton retour */}
      <motion.div
        className="mt-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        <Link
          to="/"
        >
          <button className="default-button">
            <span>Retour a la page d'accueil</span>
          </button>
        </Link>
      </motion.div>
    </div>
  );
}
